export interface FirstTouch {
  referrer: string | null;
  landing_page: string | null;
  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
}

const KEY = 'first-touch-v1';

const empty = (): FirstTouch => ({
  referrer: null,
  landing_page: null,
  utm_source: null,
  utm_medium: null,
  utm_campaign: null,
});

export function captureFirstTouch(): void {
  if (typeof window === 'undefined') return;
  try {
    if (sessionStorage.getItem(KEY)) return;
    const params = new URLSearchParams(window.location.search);
    const data: FirstTouch = {
      referrer: document.referrer || null,
      landing_page: window.location.href,
      utm_source: params.get('utm_source'),
      utm_medium: params.get('utm_medium'),
      utm_campaign: params.get('utm_campaign'),
    };
    sessionStorage.setItem(KEY, JSON.stringify(data));
  } catch {
    // no-op (private mode, etc.)
  }
}

export function getFirstTouch(): FirstTouch {
  if (typeof window === 'undefined') return empty();
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return empty();
    const parsed = JSON.parse(raw);
    return {
      referrer: parsed.referrer ?? null,
      landing_page: parsed.landing_page ?? null,
      utm_source: parsed.utm_source ?? null,
      utm_medium: parsed.utm_medium ?? null,
      utm_campaign: parsed.utm_campaign ?? null,
    };
  } catch {
    return empty();
  }
}